// Imports
import { getStorage, setStorage, deleteStorage } from 'src/lib/storage.js';
import { isDevelopment } from 'src/lib/utils.js';
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';



// Stateful components

export class StudentCentreIframes extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {};

        // Binds
        this.renderPageContent = this.renderPageContent.bind(this);
    }
    
    componentDidMount() {
        var this_component = this;

        if(!isDevelopment()) {
            setTimeout(function(){
                this_component.checkForPeoplesoftToken();
            }, 100);            
        }
        
        this_component.renderPageContent();
    }


    //
    // Functions
    //

    checkForPeoplesoftToken() {
        var peoplesoft_cookie_name = 'SignOnDefault';
        var peoplesoft_cookie = getStorage('find_cookie', peoplesoft_cookie_name);
        var switch_storage_key = 'gua-switch';

        /*console.log('in check for token');
        console.log(document.cookie.split('; '));
        console.log(peoplesoft_cookie);*/
        
        if(peoplesoft_cookie.length === 0) {
            // This cookie hasn't been set, which assumes you have no PeopleSoft session active
            setStorage('session', switch_storage_key, 'true');
        } else {
            // The cookie exists, which assumes a PeopleSoft session is active
            deleteStorage('session', switch_storage_key);
        }
    }

    renderPageContent(context) {
        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var requested_object = null;
        var requested_path_type = null;
        var backup_path_type = null;
        var requested_page_path = null;
        var requested_page_url = null;
        var display_name = null;
        var base_load = true;

        var browser_query = window.location.hash.replace(/^#?|\/$/g, '');
        var initial_character = browser_query.charAt(0);
        
        // Only do things if it's a page path
        if(initial_character === '' || initial_character === '/') {
            browser_query = browser_query.replace('/', '');
            browser_query = browser_query.split('/');

            if(browser_query.length > 1){
                base_load = false;
                
                requested_page_path = browser_query[browser_query.length - 1];
                // peoplesoft edit link

                // if the path is NOT an ID, then look for a friendly path name instead
                if(isNaN(requested_page_path)){
                    requested_path_type = 'path';

                    // Handle rare edge case of a PeopleSoft path provided
                    backup_path_type = 'lookup_url';
                }
                // get the object
                requested_object = helpers.getDynamicLinkObject(requested_page_path, requested_path_type, backup_path_type);
    
                if(requested_object){
                    if(typeof requested_object['name'] != 'undefined'){
                        display_name = ' > ' + requested_object['name'];
                    }
                    if(typeof requested_object['url'] != 'undefined'){
                        requested_page_url = requested_object['url'];

                        // added for https://squizgroup.atlassian.net/browse/SUP-12523 
                        // if the following param is true, redirect the user to the url instead of iframing it in.
                        if(typeof requested_object['new_window'] != 'undefined' ){
                            if(requested_object['new_window'] === 'true'){
                                window.location.href = requested_page_url;
                            }                            
                        }
                    }    
                }
            }

        }

        return (
            <div id="main__content" className="page-inner__wrapper">
                <div className="page-header__wrapper">
                    <div className="inner">
                        <h1 className="page-header__title">Student Centre</h1>
                    </div>
                </div>

                <div className="page-inner__header">
                    <h1 className="page-header__title">Student Centre</h1>
                </div>

                <div className="page-inner__content">   
                {requested_page_url ? (
                    <div className="student-centre-iframe">
                        <iframe id="sciframe" name="TargetContent" frameBorder="0" scrolling="yes" marginHeight="0" marginWidth="0" src={requested_page_url}></iframe>
                    </div>
                ) : (
                    <div className="student-centre">
                        <p>Student center page not found</p>
                    </div>
                )}
                </div>
            </div>
        )
    }


    //
    // Render
    //

    render() {
        var this_component = this;
        
        return (
           <this_component.renderPageContent />
        );
    }

};

StudentCentreIframes.contextType = PortalContext;